const $ = require('jquery');

const paCountdown = function () {
	const $counter = $('.js-counter');
	let interval = null;
	//console.log('has counter', $counter);
	function tickDate() {
		let now = new Date();
		let dateString = $counter.data('counterTime');

		let gameDate = new Date(dateString);
		let days = 0, hours = 0, minutes = 0, seconds = 0;

		//console.log('tick',dateString, gameDate);
		if (gameDate > now) {
			// get total seconds between the times
			let delta = Math.abs(gameDate - now) / 1000;

			// calculate (and subtract) whole days
			days = Math.floor(delta / 86400);
			delta -= days * 86400;

			// calculate (and subtract) whole hours
			hours = Math.floor(delta / 3600) % 24;
			delta -= hours * 3600;

			// calculate (and subtract) whole minutes
			minutes = Math.floor(delta / 60) % 60;
			delta -= minutes * 60;

			// what's left is seconds
			seconds = Math.floor(delta) % 60;  // in theory the modulus is not required
		}
		else
		{
			window.clearInterval(interval);
		}
		//console.log(days, hours, minutes, seconds);

		if (days < 0) days = 0;
		if (hours < 0) hours = 0;
		if (minutes < 0) minutes = 0;
		if (seconds < 0) seconds = 0;

		if (days < 10) days = '0' + days;
		if (hours < 10) hours = '0' + hours;
		if (minutes < 10) minutes = '0' + minutes;
		if (seconds < 10) seconds = '0' + seconds;

		$('.js-day').text(days);
		if (days == 0) {
			$('.js-day').addClass('has-text-quarternary');
		}
		$('.js-hour').text(hours);
		if (days == 0 && hours == 0) {
			$('.js-hour').addClass('has-text-quarternary');
		}
		$('.js-minute').text(minutes);
		if (days == 0 && hours == 0 && minutes == 0) {
			$('.js-minute').addClass('has-text-quarternary');
		}
		$('.js-second').text(seconds);
	}

	if ($counter.length > 0) {
		//console.log('has counter true', $counter);

		tickDate();
		interval = window.setInterval(tickDate, 1000);

	}
};

module.exports = paCountdown;
